import {Torneo, TorneoJSON } from '../Torneo/Torneo';
import { Equipo, EquipoJSON } from '../Equipo/Equipo';
export interface TorneoListaBuenaFeJSON {
    tlbf_id: string;
    tlbf_torid: string;
    tlbf_eqid: string;
    tlbf_responsable_apellido: string;
    tlbf_responsable_nombre: string;
    tlbf_responsable_documento_numero: string;
    tlbf_responsable_telefono_numero: string;
    tlbf_responsable_email: string;
    tlbf_estado: string;
    torneo: TorneoJSON | null;
    equipo: EquipoJSON | null;
}

export class TorneoListaBuenaFe {
    protected constructor(
    private id: string,
    private torid: string,
    private eqid: string,
    private responsableApellido: string,
    private responsableNombre: string,
    private responsableDocumentoNumero: string,
    private responsableTelefonoNumero: string,
    private responsableEmail: string,
    private estado: string,
    private torneo: Torneo | null,
    private equipo: Equipo | null) {}

    static createFrom( id: string,
    torid: string,
    eqid: string,
    responsableApellido: string,
    responsableNombre: string,
    responsableDocumentoNumero: string,
    responsableTelefonoNumero: string,
    responsableEmail: string,
    estado: string,
    torneo: Torneo | null,
    equipo: Equipo | null) {
        return new this( id,
        torid,
        eqid,
        responsableApellido,
        responsableNombre,
        responsableDocumentoNumero,
        responsableTelefonoNumero,
        responsableEmail,
        estado,
        torneo,
        equipo)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: TorneoListaBuenaFe) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: TorneoListaBuenaFeJSON) {
        return TorneoListaBuenaFe.createFrom( entity.tlbf_id,
        entity.tlbf_torid,
        entity.tlbf_eqid,
        entity.tlbf_responsable_apellido,
        entity.tlbf_responsable_nombre,
        entity.tlbf_responsable_documento_numero,
        entity.tlbf_responsable_telefono_numero,
        entity.tlbf_responsable_email,
        entity.tlbf_estado,
        entity.torneo ? Torneo.fromJSON(entity.torneo) : null,
        entity.equipo ? Equipo.fromJSON(entity.equipo) : null)
    }

    toJSON(): TorneoListaBuenaFeJSON {
        return {
            tlbf_id: this.getId(),
            tlbf_torid: this.getTorid(),
            tlbf_eqid: this.getEqid(),
            tlbf_responsable_apellido: this.getResponsableApellido(),
            tlbf_responsable_nombre: this.getResponsableNombre(),
            tlbf_responsable_documento_numero: this.getResponsableDocumentoNumero(),
            tlbf_responsable_telefono_numero: this.getResponsableTelefonoNumero(),
            tlbf_responsable_email: this.getResponsableEmail(),
            tlbf_estado: this.getEstado(),
            torneo: null,
            equipo: null
        }

    }

    getId(): string { return this.id; }

    getTorid(): string { return this.torid; }

    getEqid(): string { return this.eqid; }

    getResponsableApellido(): string { return this.responsableApellido; }

    getResponsableNombre(): string { return this.responsableNombre; }

    getResponsableDocumentoNumero(): string { return this.responsableDocumentoNumero; }

    getResponsableTelefonoNumero(): string { return this.responsableTelefonoNumero; }

    getResponsableEmail(): string { return this.responsableEmail; }

    getEstado(): string { return this.estado; }

    getTorneo(): Torneo | null { return this.torneo; }
    getEquipo(): Equipo | null { return this.equipo; }

}

